/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Tab_DescInputs */



/**
* | output |
* | --- |
* | "Select a media version for playback, or import a new file." |
*
* @param {Media_Tab_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_tab_desc = /** @type {((inputs?: Media_Tab_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Tab_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez une version multimédia pour la lecture, ou importez un nouveau fichier.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie eine Medienversion zur Wiedergabe aus oder importieren Sie eine neue Datei.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona una versione del file multimediale da riprodurre oppure importa un nuovo file.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите версию медиафайла для воспроизведения или импортируйте новый файл.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione una versión multimedia para su reproducción o importe un archivo nuevo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择要播放的媒体版本，或导入新文件。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("再生するメディアバージョンを選択するか、新しいファイルをインポートしてください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्लेबैक के लिए मीडिया संस्करण चुनें, या एक नई फ़ाइल आयात करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione uma versão de mídia para reprodução ou importe um novo arquivo.")
	return /** @type {LocalizedString} */ ("Select a media version for playback, or import a new file.")
});